import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { LabelWidthTypes } from "@enums/label-width-types";
import { FormattedRpServiceConfigurationPolicyConfigDecision } from "@idw-types/data/rp-service-configuration";
import styles from "./decision-header-container.less";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListOl } from "@fortawesome/free-solid-svg-icons/faListOl";

type DecisionHeaderContainerProps = {
    isDisabled: boolean;
    decision: FormattedRpServiceConfigurationPolicyConfigDecision;
    title: string;
    showDragAndDropIndicatorIcon: boolean;
    copyDecision: (decision: FormattedRpServiceConfigurationPolicyConfigDecision) => void;
    copyOppositeDecision: (decision: FormattedRpServiceConfigurationPolicyConfigDecision) => void;
    removeDecision: (decision: FormattedRpServiceConfigurationPolicyConfigDecision) => void;
};

export const DecisionHeaderContainer = (props: DecisionHeaderContainerProps) => {
    const { 
        isDisabled,
        decision,
        title,
        showDragAndDropIndicatorIcon,
        copyDecision,
        copyOppositeDecision,
        removeDecision
    } = props;

    const handleCopyDecision = () => {
        copyDecision(decision);
    };

    const handleCopyOppositeDecision = () => {
        copyOppositeDecision(decision);
    };

    const handleRemoveDecision = () => {
        removeDecision(decision);
    };

    return (
        <div className={styles.decisionHeaderContainer}>
            <div className={styles.headerContainer}>
                {showDragAndDropIndicatorIcon && <span className={styles.indicator}>
                    <FontAwesomeIcon className={styles.listIcon} icon={faListOl} />
                </span>}
                <span className={styles.title}>{title}</span>
                {!isDisabled && (
                    <div className={styles.buttonContainer}>
                        {/* @ts-ignore */}
                        <DropdownButton size={LabelWidthTypes.EXTRA_SMALL} variant={"outline-primary"} className={styles.dropdownButton} title={""}>
                            <Dropdown.Item
                                id="policy-decision-dropdown-menu-item-copy"
                                key={`policy-decision-dropdown-menu-item-copy`}
                                className={styles.dropdownItem}
                                as="button"
                                title={"Copy into new rule"}
                                onClick={handleCopyDecision}
                            >
                                <span className={styles.dropdownItemText}>{"Copy into new rule"}</span>
                            </Dropdown.Item>
                            <Dropdown.Item
                                id={`policy-decision-dropdown-menu-item-copy-opposite`}
                                key={`policy-decision-dropdown-menu-item-copy-opposite`}
                                className={styles.dropdownItem}
                                as="button"
                                title={"Copy opposite into new rule"}
                                onClick={handleCopyOppositeDecision}
                            >
                                <span className={styles.dropdownItemText}>{"Copy opposite into new rule"}</span>
                            </Dropdown.Item>
                            <Dropdown.Item
                                id={`policy-decision-dropdown-menu-item-remove`}
                                key={`policy-decision-dropdown-menu-item-remove`}
                                className={styles.dropdownItem}
                                as="button"
                                title={"Remove"}
                                onClick={handleRemoveDecision}
                            >
                                <span className={styles.dropdownItemText}>{"Remove"}</span>
                            </Dropdown.Item>
                        </DropdownButton>
                    </div>
                )}
            </div>
            <hr />
        </div>
    );
};